import { useCallback, useEffect, useState, Fragment } from "react";
import { Button, Grid, TextField } from "@mui/material";

import { ButtonContainer, StyledStack, StyledTitle } from "./gallery.style";

// material icons
import CheckIcon from "@mui/icons-material/Check";

import DrawerCM from "components/shared/Drawer";
import Upload from "components/shared/Upload";
import Toast from "helper/toast";
import LoadingCM from "components/shared/Loading";
import ProgressBarCM from "components/shared/ProgressBar";
import useHttp from "hooks/use-http";

import { validateImg, galleryContentSchema } from "validations";
import {
  addGalleryRequest,
  deleteGalleryRequest,
  getGalleryRequest,
} from "api/requests/gallery";
import DeleteModal from "components/shared/Modal/Delete";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

function Gallery() {
  const [image, setImage] = useState({ data: [], count: 0 });
  const { request, loading, isUploading, setUploadProgress, uploadProgress } =
    useHttp(false);

  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(galleryContentSchema),
  });

  // upload image state
  const [galleryImage, setGalleryImage] = useState({
    url: null,
    isChanged: false,
  });

  // uploaded image handler
  const handleImageChange = (val) => {
    validateImg(val);
    setGalleryImage({
      url: val,
      isChanged: true,
    });
  };

  const onSubmit = async (data) => {
    if (!galleryImage.url) return Toast({ type: "empty", title: "فیلد عکس " });
    const res = await request({
      url: () =>
        addGalleryRequest(
          {
            ...data,
            image: galleryImage,
          },
          (progress) => setUploadProgress(progress)
        ),
      isFile: true,
    });

    if (res) {
      Toast({ type: "success", title: "آپلود عکس" });
      setGalleryImage({ url: null, isChanged: false });
      reset({ alt: "", meta_description: "", keyword: "" });
      getImages();
    }
  };

  // delete modal state
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  //handle delete modal
  const handelShowModal = () => setShowDeleteModal((state) => !state);
  const [delelteItemId, setDeleteItemId] = useState();

  const handelDelete = async (id) => {
    const res = await request({
      url: deleteGalleryRequest,
      values: id,
    });
    if (res) Toast({ type: "success", title: "حذف" });
    handelShowModal();
    getImages();
  };

  const getImages = useCallback(async () => {
    const res = await request({
      url: getGalleryRequest,
    });

    if (res) {
      let transformedData = res.data.data.map((items) => ({
        id: items.id,
        image: items.image,
      }));

      setImage({ data: transformedData, count: res.data.count });
    }
  }, [request]);

  useEffect(() => {
    getImages();
  }, [getImages]);

  return (
    <Fragment>
      <DrawerCM title="تصاویر گالری">
        {isUploading ? (
          <ProgressBarCM value={uploadProgress} />
        ) : loading ? (
          <LoadingCM />
        ) : (
          <Grid container my={2} spacing={2}>
            <StyledStack>
              <StyledTitle>افزودن عکس </StyledTitle>
              <Grid container my={1} spacing={2}>
                <Grid item md={6} xs={12} p={1.2}>
                  {galleryImage.url ? (
                    <Upload
                      isWeb={galleryImage.isWeb}
                      isLocal={!galleryImage.isWeb}
                      file={galleryImage.url}
                      refillable
                      type="add-gallery-image"
                      onChange={handleImageChange}
                      width={"100%"}
                      height={"100%"}
                      objectFit="contain"
                    />
                  ) : (
                    <Upload
                      isLocal={galleryImage.isChanged}
                      file={galleryImage.url}
                      refillable
                      type="add-gallery-image"
                      onChange={handleImageChange}
                      width={"100%"}
                      height={"100%"}
                      objectFit="contain"
                    />
                  )}
                </Grid>
                <Grid item md={6} xs={12} p={1.2} flexDirection="column">
                  <Grid item xs={12} mb={3}>
                    <TextField
                      label="متن جایگزین"
                      variant="outlined"
                      fullWidth
                      id="alt"
                      {...register("alt")}
                      error={Boolean(errors.alt)}
                      helperText={errors.alt?.message}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      label="کلمه کلیدی"
                      variant="outlined"
                      fullWidth
                      id="keyword"
                      {...register("keyword")}
                      error={Boolean(errors.keyword)}
                      helperText={errors.keyword?.message}
                    />
                  </Grid>
                </Grid>
                <Grid item xs={12} p={1.2}>
                  <TextField
                    label="فرا توضیحات"
                    variant="outlined"
                    fullWidth
                    id="meta_description"
                    {...register("meta_description")}
                    error={Boolean(errors.meta_description)}
                    helperText={errors.meta_description?.message}
                  />
                </Grid>
                <ButtonContainer>
                  <Button
                    startIcon={<CheckIcon />}
                    variant="contained"
                    sx={{ mt: 1 }}
                    onClick={handleSubmit(onSubmit)}
                  >
                    ذخیره
                  </Button>
                </ButtonContainer>
              </Grid>
            </StyledStack>
            <StyledStack>
              <Grid container my={1} spacing={2}>
                {image.data.map((items, index) => {
                  return (
                    <Grid
                      item
                      md={4}
                      sm={6}
                      xs={12}
                      key={"gallery-img" + index}
                    >
                      <Upload
                        file={items.image}
                        isWeb
                        type="gallery-images"
                        onDelete={() => {
                          setDeleteItemId(items.id);
                          handelShowModal();
                        }}
                        width="100%"
                        height="100%"
                        objectFit="contain"
                      />
                    </Grid>
                  );
                })}
              </Grid>
            </StyledStack>
          </Grid>
        )}
      </DrawerCM>
      <DeleteModal
        show={showDeleteModal}
        onClose={handelShowModal}
        onDelete={handelDelete.bind(null, delelteItemId)}
      />
    </Fragment>
  );
}
export default Gallery;
